<script setup lang="ts">
interface Props {
  vehicleType?: number
  id: number | string | null
  action: (id: string | number | null) => void
  registration?: string
}
const props = withDefaults(defineProps<Props>(), {
  vehicleType: undefined,
  registration: undefined,
})

const { getReferentialOptions } = useReferentialStore()

const typeText = computed(() => {
  const typeEntry = getReferentialOptions('vehicle_type_choices').find(({ value }) => value === props.vehicleType)
  return typeEntry?.text
})
</script>

<template>
  <div class="relative flex flex-wrap items-center justify-between gap-4 rounded border border-gray-200 p-4">
    <div class="flex items-center space-x-4">
      <div class="w-16">
        <YscIconsTypeVehicle
          v-if="vehicleType"
          :type="vehicleType"
        />
      </div>
      <div>
        <h2
          v-if="typeText"
          class="font-semibold"
        >
          {{ typeText }}
        </h2>
        <p
          v-if="registration"
          class="h-6"
        >
          {{ registration }}
        </p>
      </div>
    </div>
    <div class="hidden md:block">
      <p class="text-xs font-semibold uppercase text-red-500">
        {{ $t('pages.onboarding.start.draft_state') }}
      </p>
    </div>
    <button
      class="btn btn-secondary"
      style="position: initial;"
      tabindex="0"
      @click="action(id)"
    >
      <span
        class="absolute inset-0"
        aria-hidden="true"
      />
      {{ $t('commons.actions.complete') }}
    </button>
  </div>
</template>
